module.exports = __webpack_public_path__ + "static/life-primary@large-2d1fadbffdc596ceb03ee1e244109b96.jpg";